/**
 * A página de pagamento abre em OUTRA aba (pedido dela, 22/10).
 *
 * O navegador só deixa abrir aba no gesto da pessoa: aberta depois de esperar o
 * servidor, ela é bloqueada como pop-up. Então a aba nasce em branco NO CLIQUE,
 * e recebe o endereço quando ele chega. Deu erro, ela fecha. Bloqueada mesmo
 * assim (algum navegador mais rígido), o pagamento abre nesta aba.
 */
export interface AbaDePagamento {
  ir: (url: string) => void;
  fechar: () => void;
}

export const abrirAbaDePagamento = (): AbaDePagamento => {
  let aba: Window | null = null;
  try { aba = window.open('', '_blank'); } catch { aba = null; }
  if (aba) {
    try {
      aba.document.title = 'Abrindo o pagamento...';
      aba.document.body.style.cssText = 'font-family:system-ui,sans-serif;display:grid;place-items:center;height:100vh;margin:0;color:#4b5563';
      aba.document.body.textContent = 'Abrindo o pagamento...';
    } catch { /* outra origem: segue */ }
  }
  return {
    ir: (url: string) => {
      if (aba && !aba.closed) {
        try { aba.opener = null; } catch { /* segue */ }
        aba.location.href = url;
      } else {
        window.location.assign(url);
      }
    },
    fechar: () => { try { if (aba && !aba.closed) aba.close(); } catch { /* segue */ } },
  };
};
